<template>
  <CFooter :fixed="false">
    <div>
      <span>by Mazars R&D</span>
    </div>
    <div class="mfs-auto">
      <component
          :is="link.link ? 'a' : 'span'"
          v-for="link in links"
          :key="link.text"
          target="_blank"
          :href="link.link"
          class="mr-3"
      >
        <i class="fa mr-1" :class="link.icon"></i>
        {{ link.text }}
      </component>
      <span>&copy; {{ currentYear }} Mazars</span>
    </div>
  </CFooter>
</template>

<script>
import { FooterService } from "@/services/footer";

export default {
  name: "TheFooter",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
  data() {
    return {
      links: null,
    };
  },
  async mounted() {
    this.links = await FooterService.fetchLinks();
  },
};
</script>
